import type { Translatable } from "@@/shared/translations/translation";
import type { Except } from "type-fest";

/**
 * Default error response from server Api
 * @param {Omit<ApiError, "_type">} params
 * @returns {ApiError}
 */
type ApiError = {
    _type: "API_ERROR";
    /**
     * HTTP status code
     * @type {number}
     */
    statusCode: number;
    /**
     * Error code
     * @type {string}
     */
    errorCode?: string;
    /**
     * Public title for reason about what went wrong that can be shown to
     * end users of the application
     * @type {Translatable}
     */
    reasonTitle?: Translatable;
    /**
     * Public message about what went wrong that can be shown to
     * end users of the application
     * @type {Translatable}
     */
    reason: Translatable;
    /**
     * An optional deeper explenation NOT TO BE shown in UI to end users
     * @type {Translatable}
     */
    explanation?: Translatable;
};

const apiErrorFactory = (params: Except<ApiError, "_type">): ApiError => {
    return {
        _type: "API_ERROR",
        ...params,
    };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isApiError = (error: any): error is ApiError => {
    return error?._type === "API_ERROR";
};

export { apiErrorFactory, isApiError };
export type { ApiError };
